import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 12px;
  padding-left: 15px;
  padding-right: 15px;
  
  img{
    width: 122px;
    height: 36px;
  }
  
  p{
    font-family: 'EnzoOT',sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #9E9E9E;
    margin-bottom: 10px;
  }
  
  @media (min-width: 900px){
    height: 90px;
    padding: 0 50px;
    margin: 35px 0;
    img{
      width: 305px;
      height: 90px;
    }
    
    p{
      font-size: 24px;
    }
  }
`

const logo = require('../../assets/icons/logo.png')

const Header = () => {

    return (
        <Wrapper>
            <img src={logo} alt=''/>
            <p>INTAKE FORMULIER MKB</p>
        </Wrapper>
    )
}

export default Header
